import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import Pagination_Holder from "../common-components/pagination_holder/Pagination_Holder";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../features/products/productsSlice";
import { variant_type } from "../../utils/common";
import FilterOffcanvas from "./filterOffcanvas/FilterOffcanvas";

function Categories() {
  const [showFilter, setShowFilter] = useState(false);

const handleShowFilter = () => {
  setShowFilter(true);
};

const handleCloseFilter = () => {
  setShowFilter(false);
};
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [onPageChange, setOnPageChange] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modelSearch, setModelSearch] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const category = useSelector((state) => state.master.categories);
  const all_products = useSelector((state) => state.product.allProducts);

  const category_Id = location.state?.category_id;
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  // Static subcategories array mapping exactly to image_f3bf25.png
  // Tip: You can adjust the "id" properties here to match what your backend API expects!
  const staticSubCategories = [
    { id: "2", name: "2 MP" },
    { id: "4", name: "4 MP" },
    { id: "6", name: "6 MP" },
    { id: "8", name: "8 MP" },
    { id: "project", name: "Project Models" }
  ];

  useEffect(() => {
    setSelectedCategoryId(category_Id || category[0]?.id || "");
  }, [category, category_Id]);

  const params = new URLSearchParams(location.search);
  const search = params.get("search");

  // Automatically fires whenever a category OR a static subcategory is clicked
  useEffect(() => {
    if (selectedCategoryId) {
      dispatch(
        getAllProducts({
          name: search,
          category_id: selectedCategoryId,
          subcategory_id: selectedSubCategory, // This now changes the products list dynamically!
          page: onPageChange,
        })
      );
    }
  }, [selectedCategoryId, onPageChange, search, selectedSubCategory, dispatch]);

  useEffect(() => {
    if (all_products && all_products.data) {
      setTotalPages(all_products.total_pages || 1);
      setOnPageChange(all_products.current_page || 1);
    }
  }, [all_products]);

  const handlePageChange = (pageNumber) => {
    setOnPageChange(pageNumber);
  };

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];

  return (
    <>
    <section className="categories-page-wrapper">
      <div className="container-fluid py-3 px-md-4">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <div className="row mt-3">
          {/* Left Sidebar Layout */}
         <div className="col-lg-3 col-md-4 mb-4 desktop-filter-sidebar">
            <div className="filter-sidebar-card">
              <h5 className="sidebar-main-title">Filter By</h5>
              
              {/* Product Model input search */}
              <div className="filter-group mb-4">
                <label className="sidebar-label">Product</label>
                <div className="d-flex flex-column gap-2 mt-1">
                  <input
                    type="text"
                    className="form-control model-search-input"
                    placeholder="Enter Model No."
                    value={modelSearch}
                    onChange={(e) => setModelSearch(e.target.value)}
                  />
                  <button className="btn btn-filter-action d-flex align-items-center justify-content-center gap-2">
                    <i className="bi bi-search"></i> FILTER
                  </button>
                </div>
              </div>

              {/* Categories Navigation Tree with Static Subcategories */}
              <div className="filter-group">
                <label className="sidebar-label mb-2">Categories</label>
                <ul className="sidebar-category-list">
                  {category?.map((item) => {
                    const isSelected = String(selectedCategoryId) === String(item.id);
                    
                    return (
                      <li key={item.id} className="category-list-wrapper">
                        {/* Main Category Header Row */}
                        <div
                          className={`category-item d-flex justify-content-between align-items-center ${
                            isSelected ? "active" : ""
                          }`}
                          onClick={() => {
                            setSelectedCategoryId(item.id);
                            setSelectedSubCategory(null); // Reset subcategory selection when moving to a new main category
                            setOnPageChange(1); // Reset page numbers back to 1
                            navigate(location.pathname, { replace: true, state: {} });
                          }}
                        >
                          <span className="category-name-text">{item.name}</span>
                          <span className="category-count-badge">({item.product_count || 0})</span>
                        </div>

                        {/* Static Subcategory Accordion List */}
                        {isSelected && (
                          <ul className="sidebar-subcategory-list animate-fade-down">
                            {staticSubCategories.map((sub) => (
                              <li
                                key={sub.id}
                                className={`subcategory-item ${
                                  selectedSubCategory === sub.id ? "sub-active" : ""
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation(); // Stops parent container click events from overriding
                                  setSelectedSubCategory(sub.id);
                                  setOnPageChange(1); // Reset page numbers to page 1 on search filter change
                                }}
                              >
                                <span className="bullet-dot">•</span> {sub.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>

          {/* Right Panel Main Products Grid Display Layout */}
          <div className="col-lg-9 col-md-8">
            {/* Upper control horizontal status bar */}

            <div className="mobile-filter-btn">
  <button
    className="btn"
    onClick={handleShowFilter}
  >
    <i className="bi bi-funnel-fill me-2"></i>
    Filter Products
  </button>
</div>
            <div className="products-top-bar d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
              <div className="results-count-msg">
                We found <span className="highlight-count">{all_products?.total || 0} Items</span>
              </div>
            </div>

            {/* Selected Active Header */}
            <div className="d-sm-flex d-block justify-content-between align-items-center border-bottom pb-2 mb-4">
              <div className="d-flex align-items-baseline gap-2 mb-sm-0 mb-3">
                <h3 className="active-category-title-heading text-capitalize m-0">
                  {category?.find((c) => String(c.id) === String(selectedCategoryId))?.name || "Products"}
                </h3>
              </div>
              <button 
                className="btn btn-outline-dark btn-sm show-all-btn-action fw-bold px-3"
                onClick={() => {
                  setSelectedSubCategory(null); // Clears filters back to show everything
                }}
              >
                SHOW ALL
              </button>
            </div>

            {/* Dynamic Card Display */}
            {all_products?.data?.length <= 0 ? (
              <div className="text-center py-5">
                <p className="text-danger fw-semibold">No products available for this selection.</p>
              </div>
            ) : (
              <div className="row g-1">
                {all_products?.data?.map((product, index) => {
                  let metal = product?.Product_Variants?.[0];
                  let size = Number(product?.variant_type_id) === Number(variant_type.Double) || Number(product?.variant_type_id) === Number(variant_type.Triple) ? metal?.Double_Variants?.[0] : null;
                  let triple = Number(product?.variant_type_id) === Number(variant_type.Triple) ? size?.Triple_Variants?.[0] : null;

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-xl-3 col-md-6 col-sm-6 col-6 "
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                        productName={product?.name}
                        priceText={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={activeVariant?.name}
                        savingPrice={
                          parseFloat(activeVariant?.mrp || 0) -
                          parseFloat(activeVariant?.price || 0)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            )}

            {/* Pagination Holder Wrapper */}
            <div className="d-flex justify-content-center mt-4">
              <Pagination_Holder
                onPageChange={onPageChange}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <FilterOffcanvas
  show={showFilter}
  handleClose={handleCloseFilter}
  modelSearch={modelSearch}
  setModelSearch={setModelSearch}
  category={category}
  selectedCategoryId={selectedCategoryId}
  selectedSubCategory={selectedSubCategory}
  setSelectedCategoryId={setSelectedCategoryId}
  setSelectedSubCategory={setSelectedSubCategory}
  setOnPageChange={setOnPageChange}
  navigate={navigate}
  location={location}
  staticSubCategories={staticSubCategories}
/>
    </>
  );
}

export default Categories;